/** @jsx jsx */
import { jsx } from "theme-ui"
import Svg from "./base"

const Icon = props => (
  <Svg width="1105" height="100" {...props}>
    <path
      fill="#B92A2E"
      d="M36.63 23.919a6.96 6.96 0 100-13.919 6.96 6.96 0 000 13.919zm8.155 9.328a8.708 8.708 0 00-8.316-6.117c-3.904 0-7.209 2.57-8.315 6.117a8.031 8.031 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.96-5.406-3.826 3.818l-1.128 1.128a3.477 3.477 0 00.521 5.353c1.5.981 2.57.657 3.448.236.343-.164.671-.378.964-.664l7.095-7.095 1.691 13.384c.086.542.257 1.049.471 1.534l-2.34 6.574c-2.756 7.737-4.162 12.405-4.162 20.621v.628c0 1.963 1.556 3.555 3.483 3.555s3.483-1.592 3.483-3.555c0-7.302 1.185-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.484 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.656-1.934l2.492-19.658c.192-1.292.192-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="19.203"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 19.203 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="16.113"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 16.113 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="20.163"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 20.163 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="19.886"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 19.886 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="13.56"
      y="81.188"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 13.56 81.188)"
    ></rect>
    <g clipPath="url(#clip0)">
      <path
        fill="#B92A2E"
        d="M10 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M13.632 84.004l-2.145-.882c-.235-.097-.588.21-.781.681-.196.475-.16.938.076 1.035l2.144.882a.926.926 0 00.502 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M88.736 23.919a6.96 6.96 0 100-13.919 6.96 6.96 0 000 13.919zm8.154 9.328a8.708 8.708 0 00-8.315-6.117 8.712 8.712 0 00-8.316 6.117 8.031 8.031 0 00-.242 1.15l-6.224 6.224c1.198-12.804-2.96-5.406-3.826 3.818l-1.128 1.128a3.477 3.477 0 00.52 5.353c1.5.981 2.57.657 3.449.236a3.58 3.58 0 00.963-.664l7.095-7.095 1.692 13.384c.085.542.257 1.049.47 1.534l-2.34 6.574c-2.756 7.737-4.162 12.405-4.162 20.621v.628c0 1.963 1.556 3.555 3.484 3.555 1.927 0 3.483-1.592 3.483-3.555 0-7.302 1.184-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53c.314-.593.55-1.242.657-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="71.309"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 71.309 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="68.219"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 68.219 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="72.269"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 72.269 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="71.991"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 71.991 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="65.665"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 65.665 81.187)"
    ></rect>
    <g clipPath="url(#clip1)">
      <path
        fill="#B92A2E"
        d="M62.105 85.519l1.41-3.427 7.717 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M65.737 84.004l-2.144-.882c-.236-.097-.588.21-.782.681-.195.475-.16.938.076 1.035l2.145.882a.926.926 0 00.501 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M140.841 23.919a6.959 6.959 0 006.959-6.96 6.959 6.959 0 10-13.918 0 6.96 6.96 0 006.959 6.96zm8.155 9.328a8.712 8.712 0 00-16.631 0 8.046 8.046 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.96-5.406-3.826 3.818l-1.128 1.128a3.477 3.477 0 00.521 5.353c1.5.981 2.57.657 3.448.236a3.58 3.58 0 00.964-.664l7.094-7.095 1.692 13.384c.086.542.257 1.049.471 1.534l-2.341 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555s3.483-1.592 3.483-3.555c0-7.302 1.185-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.484 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.138 6.138 0 00.656-1.934l2.492-19.658c.192-1.292.192-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="123.414"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 123.414 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="120.323"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 120.323 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="124.373"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 124.373 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="124.096"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 124.096 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="117.77"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 117.77 81.187)"
    ></rect>
    <g clipPath="url(#clip2)">
      <path
        fill="#B92A2E"
        d="M114.211 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M117.843 84.004l-2.145-.882c-.235-.097-.588.21-.781.681-.196.475-.16.938.076 1.035l2.144.882a.926.926 0 00.502 1.209l4.286 1.762 1.409-3.428-4.285-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M192.949 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.154 9.328a8.708 8.708 0 00-8.315-6.117c-3.905 0-7.209 2.57-8.316 6.117a8.185 8.185 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.96-5.406-3.825 3.818l-1.128 1.128a3.475 3.475 0 00.521 5.353c1.5.981 2.569.657 3.447.236a3.58 3.58 0 00.964-.664l7.095-7.095 1.692 13.384c.085.542.256 1.049.471 1.534L184.9 64.89c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555 1.928 0 3.484-1.592 3.484-3.555 0-7.302 1.184-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.657-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="175.521"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 175.521 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="172.432"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 172.432 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="176.481"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 176.481 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="176.204"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 176.204 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="169.878"
      y="81.188"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 169.878 81.188)"
    ></rect>
    <g clipPath="url(#clip3)">
      <path
        fill="#B92A2E"
        d="M166.318 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M169.95 84.004l-2.144-.882c-.236-.097-.588.21-.782.681-.195.475-.159.938.076 1.035l2.145.882a.926.926 0 00.501 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M245.052 23.919a6.959 6.959 0 006.959-6.96 6.959 6.959 0 10-13.918 0 6.96 6.96 0 006.959 6.96zm8.155 9.328a8.712 8.712 0 00-16.631 0 7.911 7.911 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.961-5.406-3.826 3.818l-1.128 1.128a3.477 3.477 0 00.521 5.353c1.5.981 2.57.657 3.448.236.342-.164.671-.378.963-.664l7.095-7.095 1.692 13.384c.086.542.257 1.049.471 1.534l-2.341 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555s3.483-1.592 3.483-3.555c0-7.302 1.185-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.484 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.138 6.138 0 00.656-1.934l2.491-19.658c.193-1.292.193-2.627-.199-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="227.625"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 227.625 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="224.534"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 224.534 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="228.584"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 228.584 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="228.307"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 228.307 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="221.98"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 221.98 81.187)"
    ></rect>
    <g clipPath="url(#clip4)">
      <path
        fill="#B92A2E"
        d="M218.422 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M222.054 84.004l-2.145-.882c-.235-.097-.588.21-.782.681-.195.475-.159.938.077 1.035l2.144.882a.926.926 0 00.502 1.209l4.286 1.762 1.409-3.428-4.285-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M297.158 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.154 9.328a8.708 8.708 0 00-8.315-6.117c-3.905 0-7.209 2.57-8.316 6.117a8.185 8.185 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.96-5.406-3.825 3.818l-1.128 1.128a3.475 3.475 0 00.521 5.353c1.5.981 2.569.657 3.447.236a3.58 3.58 0 00.964-.664l7.095-7.095 1.692 13.384c.085.542.256 1.049.471 1.534l-2.342 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555 1.928 0 3.484-1.592 3.484-3.555 0-7.302 1.184-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.657-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="279.73"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 279.73 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="276.642"
      y="74.239"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 276.642 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="280.691"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 280.691 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="280.414"
      y="81.664"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 280.414 81.664)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="274.088"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 274.088 81.187)"
    ></rect>
    <g clipPath="url(#clip5)">
      <path
        fill="#B92A2E"
        d="M270.527 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M274.159 84.004l-2.144-.882c-.236-.097-.588.21-.782.681-.195.475-.159.938.076 1.035l2.145.882a.926.926 0 00.501 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M349.263 23.919a6.959 6.959 0 006.959-6.96 6.959 6.959 0 10-13.918 0 6.959 6.959 0 006.959 6.96zm8.155 9.328a8.712 8.712 0 00-16.631 0 7.911 7.911 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.961-5.406-3.826 3.818l-1.128 1.128a3.477 3.477 0 00.521 5.353c1.5.981 2.57.657 3.448.236.342-.164.671-.378.963-.664l7.095-7.095 1.692 13.384c.086.542.257 1.049.471 1.534l-2.341 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555s3.483-1.592 3.483-3.555c0-7.302 1.185-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.921 0 3.484-1.592 3.484-3.555v-27.53a6.138 6.138 0 00.656-1.934l2.491-19.658c.193-1.292.193-2.627-.199-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="331.836"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 331.836 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="328.747"
      y="74.239"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 328.747 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="332.797"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 332.797 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="332.52"
      y="81.664"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 332.52 81.664)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="326.193"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 326.193 81.187)"
    ></rect>
    <g clipPath="url(#clip6)">
      <path
        fill="#B92A2E"
        d="M322.633 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M326.265 84.004l-2.145-.882c-.235-.097-.588.21-.782.681-.195.475-.159.938.077 1.035l2.144.882a.926.926 0 00.502 1.209l4.286 1.762 1.409-3.428-4.286-1.762a.924.924 0 00-1.205.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M401.368 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.155 9.328a8.712 8.712 0 00-16.631 0 8.185 8.185 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.96-5.406-3.826 3.818l-1.127 1.128a3.475 3.475 0 00.521 5.353c1.5.981 2.569.657 3.447.236a3.58 3.58 0 00.964-.664l7.095-7.095 1.691 13.384c.086.542.257 1.049.472 1.534l-2.342 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555s3.483-1.592 3.483-3.555c0-7.302 1.185-11.527 3.484-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.657-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="383.941"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 383.941 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="380.852"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 380.852 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="384.901"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 384.901 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="384.624"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 384.624 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="378.298"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 378.298 81.187)"
    ></rect>
    <g clipPath="url(#clip7)">
      <path
        fill="#B92A2E"
        d="M374.738 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M378.37 84.004l-2.144-.882c-.236-.097-.588.21-.782.681-.195.475-.16.938.076 1.035l2.145.882a.925.925 0 00.501 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M453.476 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.154 9.328a8.708 8.708 0 00-8.315-6.117A8.712 8.712 0 00445 33.247a7.911 7.911 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.961-5.406-3.826 3.818l-1.128 1.128a3.477 3.477 0 00.521 5.353c1.5.981 2.569.657 3.448.236.342-.164.671-.378.963-.664l7.095-7.095 1.692 13.384c.086.542.257 1.049.471 1.534l-2.341 6.574c-2.755 7.737-4.162 12.405-4.162 20.621v.628c0 1.963 1.556 3.555 3.484 3.555 1.927 0 3.483-1.592 3.483-3.555 0-7.302 1.185-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.484-1.592 3.484-3.555v-27.53a6.138 6.138 0 00.656-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="436.049"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 436.049 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="432.96"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 432.96 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="437.01"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 437.01 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="436.732"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 436.732 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="430.406"
      y="81.188"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 430.406 81.188)"
    ></rect>
    <g clipPath="url(#clip8)">
      <path
        fill="#B92A2E"
        d="M426.846 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M430.478 84.004l-2.145-.882c-.236-.097-.588.21-.782.681-.195.475-.159.938.076 1.035l2.145.882a.926.926 0 00.502 1.209l4.285 1.762 1.41-3.428-4.286-1.762a.924.924 0 00-1.205.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M505.581 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.155 9.328a8.712 8.712 0 00-16.631 0 8.046 8.046 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.96-5.406-3.826 3.818l-1.127 1.128a3.475 3.475 0 00.521 5.353c1.499.981 2.569.657 3.447.236a3.58 3.58 0 00.964-.664l7.095-7.095 1.691 13.384c.086.542.257 1.049.471 1.534l-2.341 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555s3.483-1.592 3.483-3.555c0-7.302 1.185-11.527 3.484-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.657-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="488.154"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 488.154 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="485.064"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 485.064 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="489.114"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 489.114 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="488.837"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 488.837 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="482.511"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 482.511 81.187)"
    ></rect>
    <g clipPath="url(#clip9)">
      <path
        fill="#B92A2E"
        d="M478.951 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M482.583 84.004l-2.145-.882c-.235-.097-.587.21-.781.681-.195.475-.16.938.076 1.035l2.145.882a.925.925 0 00.501 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M557.687 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.154 9.328a8.708 8.708 0 00-8.315-6.117c-3.904 0-7.209 2.57-8.316 6.117a8.043 8.043 0 00-.242 1.15l-6.224 6.224c1.198-12.804-2.961-5.406-3.826 3.818l-1.128 1.128a3.477 3.477 0 00.521 5.353c1.5.981 2.569.657 3.448.236.342-.164.671-.378.963-.664l7.095-7.095 1.692 13.384a6.16 6.16 0 00.471 1.534l-2.341 6.574c-2.755 7.737-4.162 12.405-4.162 20.621v.628c0 1.963 1.556 3.555 3.484 3.555 1.927 0 3.483-1.592 3.483-3.555 0-7.302 1.185-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.484-1.592 3.484-3.555v-27.53a6.138 6.138 0 00.656-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="540.26"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 540.26 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="537.169"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 537.169 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="541.219"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 541.219 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="540.941"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 540.941 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="534.615"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 534.615 81.187)"
    ></rect>
    <g clipPath="url(#clip10)">
      <path
        fill="#B92A2E"
        d="M531.057 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M534.689 84.004l-2.145-.882c-.236-.097-.588.21-.782.681-.195.475-.159.938.076 1.035l2.145.882a.925.925 0 00.502 1.209l4.285 1.762 1.41-3.428-4.286-1.762a.924.924 0 00-1.205.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M609.79 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.155 9.328a8.712 8.712 0 00-16.631 0 8.046 8.046 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.96-5.406-3.826 3.818l-1.127 1.128a3.475 3.475 0 00.521 5.353c1.499.981 2.569.657 3.447.236a3.58 3.58 0 00.964-.664l7.095-7.095 1.691 13.384c.086.542.257 1.049.471 1.534l-2.341 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555s3.483-1.592 3.483-3.555c0-7.302 1.185-11.527 3.484-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.657-1.934l2.491-19.658c.192-1.292.192-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="592.363"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 592.363 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="589.274"
      y="74.239"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 589.274 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="593.324"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 593.324 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="593.047"
      y="81.664"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 593.047 81.664)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="586.721"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 586.721 81.187)"
    ></rect>
    <g clipPath="url(#clip11)">
      <path
        fill="#B92A2E"
        d="M583.16 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M586.792 84.004l-2.145-.882c-.235-.097-.588.21-.781.681-.195.475-.16.938.076 1.035l2.145.882a.925.925 0 00.501 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M661.896 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.154 9.328a8.708 8.708 0 00-8.315-6.117c-3.904 0-7.209 2.57-8.316 6.117a8.043 8.043 0 00-.242 1.15l-6.224 6.224c1.198-12.804-2.961-5.406-3.826 3.818l-1.128 1.128a3.477 3.477 0 00.521 5.353c1.5.981 2.569.657 3.448.236.342-.164.671-.378.963-.664l7.095-7.095 1.692 13.384a6.16 6.16 0 00.471 1.534l-2.341 6.574c-2.755 7.737-4.162 12.405-4.162 20.621v.628c0 1.963 1.556 3.555 3.484 3.555 1.927 0 3.483-1.592 3.483-3.555 0-7.302 1.185-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.12 6.12 0 00.657-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="644.469"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 644.469 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="641.38"
      y="74.239"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 641.38 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="645.43"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 645.43 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="645.152"
      y="81.664"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 645.152 81.664)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="638.826"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 638.826 81.187)"
    ></rect>
    <g clipPath="url(#clip12)">
      <path
        fill="#B92A2E"
        d="M635.266 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M638.898 84.004l-2.145-.882c-.236-.097-.588.21-.782.681-.195.475-.159.938.076 1.035l2.145.882a.925.925 0 00.502 1.209l4.285 1.762 1.41-3.428-4.286-1.762a.924.924 0 00-1.205.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M714.001 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.155 9.328a8.712 8.712 0 00-16.631 0 8.046 8.046 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.96-5.406-3.826 3.818l-1.127 1.128a3.475 3.475 0 00.521 5.353c1.499.981 2.569.657 3.447.236a3.58 3.58 0 00.964-.664l7.095-7.095 1.691 13.384c.086.542.257 1.049.471 1.534l-2.341 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555s3.483-1.592 3.483-3.555c0-7.302 1.185-11.527 3.484-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.657-1.934l2.491-19.658c.192-1.292.192-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="696.574"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 696.574 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="693.484"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 693.484 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="697.534"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 697.534 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="697.257"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 697.257 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="690.931"
      y="81.188"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 690.931 81.188)"
    ></rect>
    <g clipPath="url(#clip13)">
      <path
        fill="#B92A2E"
        d="M687.371 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M691.003 84.004l-2.145-.882c-.235-.097-.588.21-.781.681-.196.475-.16.938.076 1.035l2.144.882a.926.926 0 00.502 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M766.109 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.154 9.328a8.708 8.708 0 00-8.315-6.117c-3.905 0-7.209 2.57-8.316 6.117a8.043 8.043 0 00-.242 1.15l-6.224 6.224c1.198-12.804-2.961-5.406-3.826 3.818l-1.128 1.128a3.477 3.477 0 00.521 5.353c1.5.981 2.569.657 3.448.236.342-.164.67-.378.963-.664l7.095-7.095 1.692 13.384a6.16 6.16 0 00.471 1.534l-2.341 6.574c-2.756 7.737-4.162 12.405-4.162 20.621v.628c0 1.963 1.556 3.555 3.484 3.555 1.927 0 3.483-1.592 3.483-3.555 0-7.302 1.185-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.657-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="748.682"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 748.682 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="745.596"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 745.596 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="749.646"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 749.646 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="749.368"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 749.368 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="743.042"
      y="81.188"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 743.042 81.188)"
    ></rect>
    <g clipPath="url(#clip14)">
      <path
        fill="#B92A2E"
        d="M739.479 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M743.11 84.004l-2.144-.882c-.236-.097-.588.21-.782.681-.195.475-.159.938.076 1.035l2.145.882a.926.926 0 00.501 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M818.214 23.919a6.959 6.959 0 006.959-6.96 6.959 6.959 0 10-13.918 0 6.96 6.96 0 006.959 6.96zm8.155 9.328a8.712 8.712 0 00-16.631 0 8.046 8.046 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.96-5.406-3.826 3.818l-1.128 1.128a3.477 3.477 0 00.521 5.353c1.5.981 2.57.657 3.448.236a3.58 3.58 0 00.964-.664l7.095-7.095 1.691 13.384c.086.542.257 1.049.471 1.534l-2.341 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555s3.483-1.592 3.483-3.555c0-7.302 1.185-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.484 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.165 6.165 0 00.657-1.934l2.491-19.658c.192-1.292.192-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="800.787"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 800.787 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="797.697"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 797.697 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="801.747"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 801.747 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="801.47"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 801.47 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="795.144"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 795.144 81.187)"
    ></rect>
    <g clipPath="url(#clip15)">
      <path
        fill="#B92A2E"
        d="M791.584 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M795.216 84.004l-2.145-.882c-.235-.097-.588.21-.781.681-.196.475-.16.938.076 1.035l2.144.882a.926.926 0 00.502 1.209l4.286 1.762 1.409-3.428-4.285-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M870.527 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.154 9.328a8.708 8.708 0 00-8.315-6.117c-3.905 0-7.209 2.57-8.316 6.117a8.043 8.043 0 00-.242 1.15l-6.225 6.224c1.199-12.804-2.96-5.406-3.825 3.818l-1.128 1.128a3.477 3.477 0 00.521 5.353c1.5.981 2.569.657 3.447.236a3.58 3.58 0 00.964-.664l7.095-7.095 1.692 13.384a6.16 6.16 0 00.471 1.534l-2.341 6.574c-2.756 7.737-4.162 12.405-4.162 20.621v.628c0 1.963 1.556 3.555 3.483 3.555 1.928 0 3.484-1.592 3.484-3.555 0-7.302 1.185-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.657-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="853.1"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 853.1 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="850.01"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 850.01 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="854.06"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 854.06 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="853.782"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 853.782 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="847.456"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 847.456 81.187)"
    ></rect>
    <g clipPath="url(#clip16)">
      <path
        fill="#B92A2E"
        d="M843.896 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M847.528 84.004l-2.144-.882c-.236-.097-.588.21-.782.681-.195.475-.159.938.076 1.035l2.145.882a.926.926 0 00.501 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M922.99 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.154 9.328a8.708 8.708 0 00-8.315-6.117c-3.905 0-7.209 2.57-8.316 6.117a8.043 8.043 0 00-.242 1.15l-6.225 6.224c1.199-12.804-2.96-5.406-3.825 3.818l-1.128 1.128a3.475 3.475 0 00.521 5.353c1.5.981 2.569.657 3.447.236a3.58 3.58 0 00.964-.664l7.095-7.095 1.692 13.384c.085.542.256 1.049.471 1.534l-2.342 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555 1.928 0 3.484-1.592 3.484-3.555 0-7.302 1.184-11.527 3.483-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.657-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="905.562"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 905.562 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="902.474"
      y="74.239"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 902.474 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="906.523"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 906.523 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="906.246"
      y="81.664"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 906.246 81.664)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="899.92"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 899.92 81.187)"
    ></rect>
    <g clipPath="url(#clip17)">
      <path
        fill="#B92A2E"
        d="M896.359 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M899.991 84.004l-2.144-.882c-.236-.097-.588.21-.782.681-.195.475-.159.938.076 1.035l2.145.882a.926.926 0 00.501 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M975.454 23.919a6.96 6.96 0 100-13.92 6.96 6.96 0 000 13.92zm8.155 9.328a8.712 8.712 0 00-16.631 0 8.046 8.046 0 00-.243 1.15l-6.224 6.224c1.199-12.804-2.96-5.406-3.826 3.818l-1.127 1.128a3.475 3.475 0 00.521 5.353c1.499.981 2.569.657 3.447.236a3.58 3.58 0 00.964-.664l7.095-7.095 1.691 13.384c.086.542.257 1.049.471 1.534l-2.341 6.574c-2.755 7.737-4.161 12.405-4.161 20.621v.628c0 1.963 1.556 3.555 3.483 3.555s3.483-1.592 3.483-3.555c0-7.302 1.185-11.527 3.484-18.066v18.173c0 1.963 1.556 3.555 3.483 3.555 1.92 0 3.483-1.592 3.483-3.555v-27.53a6.14 6.14 0 00.657-1.934l2.491-19.658c.193-1.292.193-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="958.027"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 958.027 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="954.938"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 954.938 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="958.987"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 958.987 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="958.71"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 958.71 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="952.384"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 952.384 81.187)"
    ></rect>
    <g clipPath="url(#clip18)">
      <path
        fill="#B92A2E"
        d="M948.824 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M952.456 84.004l-2.144-.882c-.236-.097-.588.21-.782.681-.195.475-.16.938.076 1.035l2.145.882a.925.925 0 00.501 1.209l4.286 1.762 1.41-3.428-4.286-1.762a.925.925 0 00-1.206.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M1026.54 23.919c3.84 0 6.96-3.116 6.96-6.96a6.962 6.962 0 00-6.96-6.959 6.956 6.956 0 00-6.96 6.96 6.956 6.956 0 006.96 6.959zm8.15 9.328a8.703 8.703 0 00-8.31-6.117c-3.91 0-7.21 2.57-8.32 6.117-.11.379-.19.764-.24 1.15l-6.23 6.224c1.2-12.804-2.96-5.406-3.82 3.818l-1.13 1.128a3.483 3.483 0 00.52 5.353c1.5.981 2.57.657 3.45.236.34-.164.67-.378.96-.664l7.1-7.095 1.69 13.384c.08.542.26 1.049.47 1.534l-2.34 6.574c-2.76 7.737-4.16 12.405-4.16 20.621v.628c0 1.963 1.55 3.555 3.48 3.555s3.48-1.592 3.48-3.555c0-7.302 1.19-11.527 3.49-18.066v18.173c0 1.963 1.55 3.555 3.48 3.555 1.92 0 3.48-1.592 3.48-3.555v-27.53a6.07 6.07 0 00.66-1.934l2.49-19.658c.19-1.292.19-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="1009.11"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 1009.11 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="1006.02"
      y="74.239"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 1006.02 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="1010.07"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 1010.07 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="1009.79"
      y="81.664"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 1009.79 81.664)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="1003.47"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 1003.47 81.187)"
    ></rect>
    <g clipPath="url(#clip19)">
      <path
        fill="#B92A2E"
        d="M999.906 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M1003.54 84.004l-2.15-.882c-.23-.097-.58.21-.78.681-.19.475-.16.938.08 1.035l2.14.882a.93.93 0 00.5 1.209l4.29 1.762 1.41-3.428-4.29-1.762a.917.917 0 00-1.2.503z"
      ></path>
    </g>
    <path
      fill="#B92A2E"
      d="M1079 23.919c3.84 0 6.96-3.116 6.96-6.96A6.962 6.962 0 001079 10a6.962 6.962 0 00-6.96 6.96 6.962 6.962 0 006.96 6.959zm8.16 9.328a8.716 8.716 0 00-16.64 0c-.11.379-.18.764-.24 1.15l-6.22 6.224c1.2-12.804-2.96-5.406-3.83 3.818l-1.13 1.128a3.483 3.483 0 000 4.925c.17.164.34.307.53.428 1.5.981 2.56.657 3.44.236.35-.164.67-.378.97-.664l7.09-7.095 1.69 13.384c.09.542.26 1.049.47 1.534l-2.34 6.574c-2.75 7.737-4.16 12.405-4.16 20.621v.628c0 1.963 1.56 3.555 3.49 3.555 1.92 0 3.48-1.592 3.48-3.555 0-7.302 1.18-11.527 3.48-18.066v18.173c0 1.963 1.56 3.555 3.48 3.555s3.49-1.592 3.49-3.555v-27.53a6.06 6.06 0 00.65-1.934l2.5-19.658c.19-1.292.19-2.627-.2-3.876z"
    ></path>
    <rect
      width="3.657"
      height="47.685"
      x="1061.57"
      y="30.701"
      fill="#B92A2E"
      rx="1.829"
      transform="rotate(5.233 1061.57 30.701)"
    ></rect>
    <rect
      width="2.053"
      height="6.005"
      x="1058.48"
      y="74.24"
      fill="#B92A2E"
      rx="1.026"
      transform="rotate(5.233 1058.48 74.24)"
    ></rect>
    <rect
      width="0.709"
      height="7.05"
      x="1062.53"
      y="79.272"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(94.617 1062.53 79.272)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="1062.26"
      y="81.665"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 1062.26 81.665)"
    ></rect>
    <rect
      width="0.709"
      height="2.366"
      x="1055.93"
      y="81.187"
      fill="#B92A2E"
      rx="0.354"
      transform="rotate(-173.932 1055.93 81.187)"
    ></rect>
    <g clipPath="url(#clip20)">
      <path
        fill="#B92A2E"
        d="M1052.37 85.519l1.41-3.427 7.716 3.173-1.41 3.428z"
      ></path>
      <path
        fill="#000"
        d="M1056 84.004l-2.14-.882c-.24-.097-.59.21-.78.681-.2.475-.16.938.07 1.035l2.15.882a.922.922 0 00.5 1.209l4.28 1.762 1.41-3.428-4.28-1.762a.932.932 0 00-1.21.503z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 68.819 35.297)"
        ></path>
      </clipPath>
      <clipPath id="clip1">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 94.872 -3.587)"
        ></path>
      </clipPath>
      <clipPath id="clip2">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 120.925 -42.471)"
        ></path>
      </clipPath>
      <clipPath id="clip3">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 146.978 -81.356)"
        ></path>
      </clipPath>
      <clipPath id="clip4">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 173.03 -120.24)"
        ></path>
      </clipPath>
      <clipPath id="clip5">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 199.083 -159.123)"
        ></path>
      </clipPath>
      <clipPath id="clip6">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 225.136 -198.007)"
        ></path>
      </clipPath>
      <clipPath id="clip7">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 251.188 -236.89)"
        ></path>
      </clipPath>
      <clipPath id="clip8">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 277.242 -275.777)"
        ></path>
      </clipPath>
      <clipPath id="clip9">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 303.295 -314.66)"
        ></path>
      </clipPath>
      <clipPath id="clip10">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 329.348 -353.545)"
        ></path>
      </clipPath>
      <clipPath id="clip11">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 355.399 -392.427)"
        ></path>
      </clipPath>
      <clipPath id="clip12">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 381.452 -431.311)"
        ></path>
      </clipPath>
      <clipPath id="clip13">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 407.505 -470.195)"
        ></path>
      </clipPath>
      <clipPath id="clip14">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 433.559 -509.08)"
        ></path>
      </clipPath>
      <clipPath id="clip15">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 459.611 -547.964)"
        ></path>
      </clipPath>
      <clipPath id="clip16">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 485.767 -587.003)"
        ></path>
      </clipPath>
      <clipPath id="clip17">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 511.999 -626.153)"
        ></path>
      </clipPath>
      <clipPath id="clip18">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 538.231 -665.306)"
        ></path>
      </clipPath>
      <clipPath id="clip19">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 563.772 -703.426)"
        ></path>
      </clipPath>
      <clipPath id="clip20">
        <path
          fill="#fff"
          d="M0 0h3.706v8.344H0z"
          transform="rotate(-67.645 590.004 -742.577)"
        ></path>
      </clipPath>
    </defs>
  </Svg>
)

export default Icon
